<ul role="tablist">
    <li *ngFor="let tab of visibleTabs" [class.selected]="tab.selected">
        <a 
            role="tab" 
            id="{{tab.labelledBy}}" 
            href="javascript:;" 
            (click)="select(tab)"   
            attr.aria-controls="{{tab.id}}"
            >{{tab.label}}</a>
    </li>
</ul>

<ng-content select="tyt-tab"></ng-content>